import { MachineDoc } from '@models';

/**
 * The database API returns each record as:
 *   { id, data: { projectId, key, version, data: <payload> }, createdAt, updatedAt }
 * Normalise so the app treats key/projectId/version as root fields and `data` as the payload.
 * Ported from the legacy MachineDocsStore.
 */
export function normalizeMachineDoc(raw: MachineDoc): MachineDoc {
  const doc = { ...(raw as any) };
  const maybeEnvelope = doc?.data;
  if (maybeEnvelope && typeof maybeEnvelope === 'object' && !Array.isArray(maybeEnvelope)) {
    const hasEnvelopeShape =
      (typeof maybeEnvelope.key === 'string' && maybeEnvelope.key) ||
      (typeof maybeEnvelope.projectId === 'string' && maybeEnvelope.projectId) ||
      typeof maybeEnvelope.version === 'number';
    if (hasEnvelopeShape) {
      if (!doc.key && typeof maybeEnvelope.key === 'string') doc.key = maybeEnvelope.key;
      if (!doc.projectId && typeof maybeEnvelope.projectId === 'string') doc.projectId = maybeEnvelope.projectId;
      if ((doc.version ?? 0) <= 0 && typeof maybeEnvelope.version === 'number') doc.version = maybeEnvelope.version;
      doc.data = maybeEnvelope.data ?? {};
    }
  }
  if (!doc.data || typeof doc.data !== 'object' || Array.isArray(doc.data)) doc.data = {};
  return doc as MachineDoc;
}

/** Stable cache key for a (projectId, key) pair. */
export function docKey(projectId: string, key: string): string {
  return `${projectId}::${key}`;
}

/** When a key resolves to multiple docs, prefer the highest version. */
export function pickHighestVersion(docs: MachineDoc[]): MachineDoc | null {
  if (!docs.length) return null;
  return docs.reduce((best, cur) => ((cur.version ?? 0) > (best.version ?? 0) ? cur : best));
}
